import { PropsWithChildren, ReactElement, useMemo } from 'react';
import styles from './InformationSection.module.scss';
import { VdsIcon } from '@volt/volt-extended-components-react';
import { AccordionStatus } from '@dmc/ui';
import type { IconColors, Colors } from '@volt/volt-basic-components/dist/types/definitions/colors';
import classNames from 'classnames';

export interface InformationSectionProps {
  status: AccordionStatus;
  title: string;
  icon: string;
  isPadded?: boolean;
  actions?: ReactElement;
}

const statusColorMap: Record<AccordionStatus, IconColors | Colors> = {
  [AccordionStatus.Healthy]: 'green-500',
  [AccordionStatus.Caution]: 'yellow-500',
  [AccordionStatus.Warning]: 'orange-500',
  [AccordionStatus.Danger]: 'red-500',
  [AccordionStatus.Informative]: 'color-icon-brand-default',
  [AccordionStatus.Neutral]: 'color-icon-medium',
};

export function InformationSection({
  status,
  title,
  icon,
  children,
  isPadded = true,
  actions,
}: PropsWithChildren<InformationSectionProps>) {
  const iconColor = useMemo(() => statusColorMap[status] ?? 'color-icon-medium', [status]);

  return (
    <section>
      <header className={styles.header}>
        <VdsIcon svgIcon={icon} size="32px" color={iconColor} />
        <div className={styles.title}>{title}</div>
        <div className={styles.actions}>{actions}</div>
      </header>
      <div className={classNames(styles.content, { [styles['content--padded']]: isPadded })}>
        {children}
      </div>
    </section>
  );
}

export default InformationSection;
